import type { Film } from "@/types/content";

export const films: Film[] = [
  {
    id: "f1",
    title: "月影妖精",
    type: "电影",
    region: "中国大陆",
    language: "国语",
    year: 2023,
    director: "沈月白",
    actors: "林清瑶、顾云舟、苏晚棠",
    duration: "118分钟",
    intro: "月圆之夜苏醒的妖精，与人间画师相遇的爱与救赎。",
    synopsis:
      "每逢月圆之夜，被封印千年的月光妖精苏谣便会在古寺后山的月桂树下苏醒。她以月光为食，以守护古城为使命，直到遇见来此写生的年轻画师沈墨。沈墨笔下的月光竟能让苏谣的灵力恢复，而苏谣的出现也让沈墨重新找回了创作的热情。然而，想要夺取妖精之力的古老门派正在靠近，两人必须在月色消散之前，揭开一段跨越千年的羁绊。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20of%20an%20ethereal%20moonlight%20fairy%20with%20glowing%20silver%20hair%20standing%20beneath%20a%20giant%20osmanthus%20tree%20under%20a%20huge%20full%20moon%2C%20magical%20particles%20floating%20in%20deep%20indigo%20night%20sky%2C%20lavender%20and%20cream%20tone%20minimal%20background%2C%20elegant%20poster%20composition%2C%20high%20detail%2C%20vertical%20layout&width=600&height=900&seq=fairy-f1-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "爱情", "月光"],
    rating: 8.6,
    popularity: 9820,
  },
  {
    id: "f2",
    title: "森林之约",
    type: "电影",
    region: "日本",
    language: "日语",
    year: 2021,
    director: "佐藤凛",
    actors: "小林结衣、中村翔太",
    duration: "104分钟",
    intro: "守护古树的森林精灵，与少女立下守护森林的约定。",
    synopsis:
      "在城市长大的少女葵，因祖母去世回到山间老宅。她在后院古樟树下遇见了自称森林精灵的男孩森。森告诉她，这片森林即将被开发商砍伐，而唯有能听懂树语的人才能唤醒沉睡的树灵。葵在半信半疑中逐渐走进了精灵的世界，也重新找回了与自然相连的心。一场关于约定与守护的温柔冒险就此展开。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20of%20a%20gentle%20forest%20spirit%20boy%20with%20translucent%20butterfly%20wings%20amid%20sunlit%20mossy%20ancient%20trees%20and%20glowing%20fireflies%2C%20soft%20green%20and%20warm%20beige%20palette%2C%20dreamy%20artistic%20background%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=fairy-f2-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "治愈", "森林"],
    rating: 8.4,
    popularity: 8730,
  },
  {
    id: "f3",
    title: "星尘精灵",
    type: "电影",
    region: "美国",
    language: "英语",
    year: 2022,
    director: "Emily Carter",
    actors: "Nora Blake、Liam Hayes",
    duration: "126分钟",
    intro: "来自星尘的精灵坠落后，与人类少年联手拯救星系。",
    synopsis:
      "一颗流星坠落在沙漠小镇，带来了名为星尘的发光精灵 Astra。她失去了返回星系的能力，必须收集散落在地球的星尘碎片。少年 Leo 在望远镜后目击了这一幕，成为她唯一的伙伴。两人穿越城市与荒野，在追捕者的阴影下完成了一场跨越星海的旅程，也让 Astra 明白了「家」真正的含义。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20fantasy%20movie%20poster%20of%20a%20celestial%20stardust%20fairy%20glowing%20with%20tiny%20stars%20and%20a%20comet%20trail%2C%20standing%20on%20a%20desert%20dune%20at%20twilight%2C%20deep%20violet%20sky%20with%20warm%20orange%20horizon%2C%20minimal%20artistic%20background%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-f3-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "冒险", "星际"],
    rating: 8.1,
    popularity: 7640,
  },
  {
    id: "f4",
    title: "花语妖精",
    type: "电影",
    region: "中国大陆",
    language: "国语",
    year: 2020,
    director: "柳青禾",
    actors: "周棠、许一诺",
    duration: "96分钟",
    intro: "寄居在花园里的花语妖精，帮女孩解开家庭心结。",
    synopsis:
      "小女孩苗苗搬到外婆留下的老房子，在荒废的花园里发现了会说话的花语妖精茉茉。茉茉能听懂每一朵花的心事，却唯独读不懂苗苗爸妈的沉默。为了让花园重新开花，苗苗与茉茉一起举办了一场花茶会，邀请了多年未聚的家人。花香之中，隔阂悄然融化。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20fantasy%20movie%20poster%20of%20a%20tiny%20flower%20fairy%20with%20petal%20wings%20sitting%20on%20a%20golden%20bloom%20in%20a%20sunny%20garden%2C%20pastel%20pink%20and%20butter%20yellow%20palette%2C%20soft%20blurred%20floral%20background%2C%20elegant%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=fairy-f4-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "家庭", "治愈"],
    rating: 8.0,
    popularity: 6120,
  },
  {
    id: "f5",
    title: "暗夜精灵王国",
    type: "电影",
    region: "英国",
    language: "英语",
    year: 2019,
    director: "Oliver Grant",
    actors: "Ethan Reed、Isla Moore",
    duration: "142分钟",
    intro: "精灵王国与暗影军团的史诗之战，公主踏上复国之路。",
    synopsis:
      "精灵王国在暗影军团的突袭下一夜崩塌，年幼的公主 Aelith 在护卫护送下逃离王城。十年后，她带着被遗忘的古老魔法归来，集结森林、湖泊与山谷三支精灵部族。为了重夺王座，也为了让被暗影吞噬的族人重见光明，她必须直面自己血脉中沉睡的暗夜之力。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20movie%20poster%20of%20an%20elf%20warrior%20princess%20in%20ornate%20silver%20armor%20holding%20a%20glowing%20blade%2C%20mystical%20forest%20kingdom%20silhouette%20behind%20her%2C%20moody%20purple%20and%20teal%20lighting%2C%20dramatic%20vertical%20poster%20composition%2C%20cinematic%20high%20detail&width=600&height=900&seq=fairy-f5-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "史诗", "冒险"],
    rating: 8.7,
    popularity: 10240,
  },
  {
    id: "f6",
    title: "妖精森林的守护者",
    type: "电影",
    region: "中国大陆",
    language: "国语",
    year: 2024,
    director: "沈月白",
    actors: "陈砚、温叙白",
    duration: "122分钟",
    intro: "新一代守护者接棒，阻止森林被黑暗侵蚀。",
    synopsis:
      "妖精森林的结界开始松动，年迈的守护者将传承交给了人类少年陈砚。他需要在七天之内找到三枚自然之印，重新点亮森林之心。一路上他结识了胆小的树精、爱唱歌的溪水妖精和沉默的夜莺骑士。当黑暗藤蔓蔓上老树时，守护者们必须相信彼此，才能拯救这片家园。",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20fantasy%20movie%20poster%20of%20a%20young%20guardian%20with%20a%20glowing%20emerald%20amulet%20facing%20a%20mystical%20enchanted%20forest%20path%2C%20tree%20spirits%20emerging%20from%20the%20shadows%2C%20rich%20jade%20green%20and%20amber%20palette%2C%20vertical%20cinematic%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-f6-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "冒险", "森林"],
    rating: 8.3,
    popularity: 8210,
  },
  {
    id: "f7",
    title: "水之精灵",
    type: "电影",
    region: "法国",
    language: "法语",
    year: 2018,
    director: "Camille Dubois",
    actors: "Juliette Renard、Hugo Marchand",
    duration: "108分钟",
    intro: "湖畔精灵与渔夫的浪漫邂逅，跨越物种的温柔恋歌。",
    synopsis:
      "在法国南部一座宁静的湖畔小镇，年轻渔夫卢卡救起了一位昏迷的少女。少女自称是湖水凝聚而成的精灵 Ondine，她必须在雨季结束前回到湖心。两人在晨雾与帆船之间相爱，却终究要面对人水两隔的命运。一个关于放手与铭记的浪漫寓言。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20of%20a%20water%20nymph%20with%20shimmering%20aqua%20hair%20emerging%20from%20a%20misty%20lake%2C%20lily%20pads%20and%20glowing%20droplets%2C%20soft%20teal%20and%20pearl%20white%20palette%2C%20dreamy%20painterly%20background%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-f7-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "爱情", "治愈"],
    rating: 8.2,
    popularity: 6980,
  },
  {
    id: "f8",
    title: "时光妖精",
    type: "电影",
    region: "韩国",
    language: "韩语",
    year: 2022,
    director: "朴智勋",
    actors: "韩瑞妍、姜道贤",
    duration: "114分钟",
    intro: "能让时间倒流的妖精，遇见只想向前走的少年。",
    synopsis:
      "时光妖精熙雅拥有回到过去的能力，却也因此永远无法停留在当下。她遇见了将全部积蓄投进小书店的少年道贤，两人在黑胶唱片与旧书页之间渐渐靠近。当熙雅一次次回到过去试图修正他的遗憾时，她终于明白，有些温暖只有向前走才能遇见。",
    poster:
      "https://readdy.ai/api/search-image?query=Melancholic%20fantasy%20movie%20poster%20of%20a%20time%20fairy%20surrounded%20by%20floating%20vintage%20clock%20faces%20and%20glowing%20sand%20grains%2C%20standing%20in%20a%20softly%20lit%20old%20bookshop%2C%20muted%20lavender%20and%20sepia%20palette%2C%20vertical%20cinematic%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-f8-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "爱情", "剧情"],
    rating: 8.5,
    popularity: 9050,
  },
  {
    id: "f9",
    title: "迷雾妖精谷",
    type: "电影",
    region: "中国大陆",
    language: "国语",
    year: 2021,
    director: "柳青禾",
    actors: "白沐、韩星野",
    duration: "110分钟",
    intro: "记者深入迷雾山谷，揭开妖精失踪之谜。",
    synopsis:
      "调查记者白沐为了一桩离奇的失踪案来到被大雾笼罩的山谷。村民口中流传着妖精带走迷路者的传说，而白沐却在迷雾深处发现了一座被遗忘的妖精村落。随着真相层层揭开，他意识到真正的危险并非妖精，而是隐藏在浓雾背后的人心。",
    poster:
      "https://readdy.ai/api/search-image?query=Mystery%20fantasy%20movie%20poster%20of%20a%20glowing%20fairy%20lantern%20floating%20in%20dense%20misty%20mountain%20valley%2C%20silhouetted%20figure%20walking%20into%20the%20fog%2C%20cool%20grey%20and%20soft%20violet%20palette%2C%20atmospheric%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=fairy-f9-poster&orientation=portrait",
    tags: ["妖精", "悬疑", "奇幻", "森林"],
    rating: 8.1,
    popularity: 7330,
  },
  {
    id: "f10",
    title: "精灵之城",
    type: "电影",
    region: "美国",
    language: "英语",
    year: 2023,
    director: "Marcus Vale",
    actors: "Ava Sinclair、Noah Bennett",
    duration: "132分钟",
    intro: "现代都市下藏着精灵之城，快递员意外卷入保卫战。",
    synopsis:
      "普通快递员丹尼在派送一个神秘包裹时，误入了藏在城市地下的精灵之城。这里的精灵用魔法维持着地面的四季与气候，而邪恶的能源公司正打算抽干他们的魔力源泉。丹尼必须与叛逆的精灵少女 Lyra 联手，在地铁隧道与摩天大楼之间展开一场惊心动魄的保卫战。",
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20action%20fantasy%20movie%20poster%20of%20a%20hidden%20glowing%20elven%20city%20beneath%20a%20modern%20metropolis%2C%20magical%20energy%20tendrils%20between%20skyscrapers%2C%20deep%20violet%20and%20electric%20orange%20accents%2C%20dynamic%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-f10-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "动作", "都市"],
    rating: 7.9,
    popularity: 6710,
  },
  {
    id: "f11",
    title: "萤火妖精",
    type: "电影",
    region: "日本",
    language: "日语",
    year: 2020,
    director: "佐藤凛",
    actors: "小林结衣、高桥凛",
    duration: "94分钟",
    intro: "夏夜萤火汇聚而成的妖精，陪伴孤独少年度过一整个夏天。",
    synopsis:
      "转学生悠太在乡村的夏夜遇见了由萤火虫凝聚而成的小妖精萤。萤只在整个夏天存在，天亮之后就会消散。为了让萤看到更多世界，悠太带她走遍稻田、溪流与烟花大会。当最后一个夏夜来临，两人在漫天萤光中许下重逢的约定。",
    poster:
      "https://readdy.ai/api/search-image?query=Healing%20anime%20style%20movie%20poster%20of%20a%20tiny%20firefly%20fairy%20glowing%20soft%20golden%20in%20a%20rice%20field%20at%20summer%20night%2C%20thousands%20of%20fireflies%20and%20a%20boy%20silhouette%2C%20warm%20amber%20and%20deep%20blue%20palette%2C%20dreamy%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=fairy-f11-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "治愈", "青春"],
    rating: 8.6,
    popularity: 8870,
  },
  {
    id: "f12",
    title: "梦之妖精",
    type: "电影",
    region: "中国大陆",
    language: "国语",
    year: 2024,
    director: "云舒",
    actors: "配音：黎星、苏晚棠",
    duration: "100分钟",
    intro: "守护梦境的妖精，帮助失眠的孩子找回甜梦。",
    synopsis:
      "在梦境与现实交界的云端，住着负责编织美梦的梦之妖精。当越来越多的孩子开始失眠，梦之妖精缈缈踏上了寻找「梦之种」的旅程。她与胆小的枕头精灵、爱吹牛的闹钟怪一同穿越噩梦森林，只为让这个世界重新拥有香甜的夜晚。",
    poster:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20fantasy%20movie%20poster%20of%20a%20dream%20fairy%20with%20translucent%20wings%20riding%20a%20cloud%20through%20a%20starry%20pastel%20sky%2C%20floating%20pillows%20and%20soft%20stars%2C%20lavender%20and%20peach%20palette%2C%20playful%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-f12-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "动画", "治愈"],
    rating: 8.4,
    popularity: 7990,
  },
  {
    id: "t1",
    title: "妖精旅馆",
    type: "电视剧",
    region: "中国大陆",
    language: "国语",
    year: 2023,
    director: "顾清时",
    actors: "林清瑶、周棠、沈砚",
    duration: "全24集",
    intro: "一间只在午夜营业的旅馆，接待形形色色的妖精客人。",
    synopsis:
      "在古城巷子深处，有一间只在午夜亮灯的旅馆，老板是一位看似年轻却活了三百年的妖精。每晚，旅馆都会迎来不同的妖精客人——寻找旧爱的狐妖、弄丢声音的鲛人、想要变成人的木偶。人类实习生小满误打误撞成为旅馆的一员，在帮客人实现心愿的过程中，也慢慢治愈了自己的伤痛。",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20fantasy%20TV%20series%20poster%20of%20a%20warm%20midnight%20inn%20run%20by%20a%20mysterious%20fairy%20innkeeper%2C%20lanterns%20and%20glowing%20windows%2C%20magical%20guests%20in%20silhouette%2C%20warm%20amber%20and%20deep%20violet%20palette%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t1-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "都市", "治愈"],
    rating: 8.8,
    popularity: 12450,
  },
  {
    id: "t2",
    title: "精灵学院",
    type: "电视剧",
    region: "日本",
    language: "日语",
    year: 2022,
    director: "佐藤凛",
    actors: "小林结衣、中村翔太、高桥凛",
    duration: "全32集",
    intro: "培养精灵使者的学院，平凡学生意外唤醒远古精灵。",
    synopsis:
      "在漂浮于云端的精灵学院里，来自各地的少年少女学习与精灵缔结契约。被视为「零天赋」的新生若叶，却在入学当天唤醒了一只沉睡千年的远古精灵。随着学院陆续发生异变，若叶与伙伴们必须解开远古精灵带来的谜题，也重新定义了「天赋」的意义。",
    poster:
      "https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20school%20TV%20poster%20of%20a%20floating%20elven%20academy%20among%20clouds%2C%20students%20with%20glowing%20spirit%20companions%2C%20bright%20sky%20blue%20and%20golden%20light%20palette%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=fairy-t2-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "校园", "青春"],
    rating: 8.3,
    popularity: 9120,
  },
  {
    id: "t3",
    title: "月之妖精传",
    type: "电视剧",
    region: "中国大陆",
    language: "国语",
    year: 2021,
    director: "沈月白",
    actors: "苏晚棠、顾云舟、白沐",
    duration: "全40集",
    intro: "月色一族的兴衰史，一位妖精女官撑起整个王朝。",
    synopsis:
      "月色一族自古以月光为源，守护着人间的昼夜秩序。女官清越在王朝倾颓之际被推上高位，她既要安抚内乱的部族，又要抵御觊觎月光之力的外敌。在权谋与情义之间，清越用四十年时间书写了一段属于妖精的王朝传奇。",
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20eastern%20fantasy%20TV%20series%20poster%20of%20an%20elegant%20fairy%20court%20lady%20in%20flowing%20moonlit%20robes%20before%20an%20ornate%20palace%2C%20full%20moon%20and%20floating%20lanterns%2C%20lavender%20and%20gold%20palette%2C%20vertical%20cinematic%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t3-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "古装", "剧情"],
    rating: 8.5,
    popularity: 10380,
  },
  {
    id: "t4",
    title: "森林精灵物语",
    type: "电视剧",
    region: "英国",
    language: "英语",
    year: 2020,
    director: "Oliver Grant",
    actors: "Isla Moore、Ethan Reed",
    duration: "全12集",
    intro: "四位森林精灵守护四季轮转的温柔日常。",
    synopsis:
      "在森林深处的精灵小屋，住着负责春、夏、秋、冬的四位精灵。每一集讲述一个季节精灵面对的小小烦恼：春雨的迟到、盛夏的干旱、落叶的悲伤、初雪的寂静。她们用彼此的陪伴，守护着森林与小镇居民一年又一年的温柔日常。",
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20seasonal%20fantasy%20TV%20series%20poster%20of%20four%20forest%20season%20sprites%20with%20leaf%20and%20flower%20wings%20in%20a%20sunlit%20woodland%20clearing%2C%20soft%20green%20and%20warm%20pastel%20palette%2C%20storybook%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t4-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "治愈", "森林"],
    rating: 8.2,
    popularity: 7210,
  },
  {
    id: "t5",
    title: "妖精猎人",
    type: "电视剧",
    region: "韩国",
    language: "韩语",
    year: 2023,
    director: "朴智勋",
    actors: "韩瑞妍、姜道贤、徐志勋",
    duration: "全16集",
    intro: "猎人与妖精之间界限模糊的都市悬疑成长故事。",
    synopsis:
      "在都市的阴影里，存在着以猎捕失控妖精为生的「妖精猎人」。新人猎人河俊在一次任务中救下了失忆的妖精少女雪，却发现她正是自己追捕名单上的目标。信任与职责的拉扯中，河俊逐渐发现猎人组织背后隐藏着更大的阴谋。",
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20mystery%20fantasy%20TV%20poster%20of%20a%20hunter%20in%20a%20long%20coat%20beside%20a%20glowing%20fairy%20girl%20in%20a%20rainy%20neon%20city%20alley%2C%20cool%20teal%20and%20warm%20orange%20contrast%20palette%2C%20dramatic%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t5-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "悬疑", "都市"],
    rating: 8.4,
    popularity: 9460,
  },
  {
    id: "t6",
    title: "精灵之歌",
    type: "电视剧",
    region: "中国大陆",
    language: "国语",
    year: 2019,
    director: "顾清时",
    actors: "周棠、陈砚",
    duration: "全36集",
    intro: "歌声明珠落入人间，音乐精灵踏上寻回失窃旋律之路。",
    synopsis:
      "掌管世间旋律的音乐精灵在加冕之日丢失了「歌声明珠」，所有音乐随之走调。她化名初音来到人间，与失意的作曲少年并肩寻找被偷走的旋律碎片。在每一座城市、每一段旅途中，他们找回了音乐，也找回了彼此的心。",
    poster:
      "https://readdy.ai/api/search-image?query=Musical%20fantasy%20TV%20poster%20of%20a%20music%20sprite%20with%20glowing%20melody%20lines%20around%20her%2C%20holding%20a%20shimmering%20pearl%2C%20soft%20stage%20light%20and%20floating%20notes%2C%20lavender%20and%20rose%20palette%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t6-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "音乐", "青春"],
    rating: 8.0,
    popularity: 6820,
  },
  {
    id: "t7",
    title: "妖精的契约",
    type: "电视剧",
    region: "美国",
    language: "英语",
    year: 2024,
    director: "Marcus Vale",
    actors: "Ava Sinclair、Liam Hayes",
    duration: "全10集",
    intro: "签订契约便能实现愿望，代价却是记忆。",
    synopsis:
      "传说中只要与妖精签订契约，就能实现一个愿望，代价是交出一段最重要的记忆。当城市里接连出现失去记忆的人，律师艾拉决定追查契约背后的真相。她与孤独的妖精契约官逐渐建立起信任，却发现自己的记忆中也藏着与妖精世界相连的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Dark%20modern%20fantasy%20TV%20poster%20of%20a%20contract%20fairy%20holding%20a%20glowing%20glowing%20sigil%20between%20his%20hands%2C%20melting%20memory%20fragments%20floating%20around%2C%20deep%20violet%20and%20amber%20palette%2C%20vertical%20cinematic%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t7-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "悬疑", "都市"],
    rating: 8.6,
    popularity: 9880,
  },
  {
    id: "t8",
    title: "云端精灵",
    type: "电视剧",
    region: "中国大陆",
    language: "国语",
    year: 2022,
    director: "云舒",
    actors: "黎星、温叙白",
    duration: "全28集",
    intro: "守护天空的云端精灵，与气象员的暖心治愈故事。",
    synopsis:
      "气象站的年轻观测员陆野，在一次雷暴中救下了从云端跌落的精灵诺诺。诺诺负责编织天气，却因为贪玩让整座城市的气候乱成一团。为了弥补过失，两人联手在天台、云海与雨幕之间，一点点找回丢失的云朵，也治愈了彼此孤独的心。",
    poster:
      "https://readdy.ai/api/search-image?query=Airy%20healing%20fantasy%20TV%20poster%20of%20a%20cloud%20sprite%20with%20soft%20white%20wings%20on%20a%20rooftop%20above%20a%20sea%20of%20clouds%2C%20sunbeams%20and%20floating%20cloud%20shapes%2C%20pale%20blue%20and%20cream%20palette%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=fairy-t8-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "治愈", "都市"],
    rating: 8.1,
    popularity: 7090,
  },
  {
    id: "t9",
    title: "妖精小镇",
    type: "电视剧",
    region: "日本",
    language: "日语",
    year: 2021,
    director: "佐藤凛",
    actors: "高桥凛、小林结衣",
    duration: "全24集",
    intro: "人类与妖精共存的小镇，一桩桩温柔的小事件。",
    synopsis:
      "在群山环抱的雾隐镇上，人类与妖精世代共居。新搬来的少女凛在镇上开了家小小的杂货铺，没想到第一个客人竟是一位来买糖的妖精。随着一个个客人的到来，凛逐渐融入了这个既热闹又温柔的小镇，也见证了许多人与妖精之间的小小奇迹。",
    poster:
      "https://readdy.ai/api/search-image?query=Charming%20slice%20of%20life%20fantasy%20TV%20poster%20of%20a%20quiet%20mountain%20town%20with%20tiny%20fairies%20and%20humans%20at%20a%20warm%20evening%20market%2C%20lantern%20light%20and%20soft%20pastel%20palette%2C%20storybook%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t9-poster&orientation=portrait",
    tags: ["妖精", "奇幻", "治愈", "日常"],
    rating: 8.3,
    popularity: 7760,
  },
  {
    id: "t10",
    title: "精灵使",
    type: "电视剧",
    region: "中国大陆",
    language: "国语",
    year: 2023,
    director: "沈月白",
    actors: "陈砚、林清瑶、韩星野",
    duration: "全30集",
    intro: "能召唤精灵的使者在现代都市中守护平衡。",
    synopsis:
      "在现代都市的地表之下，存在着维系自然平衡的精灵结界。年轻的精灵使陈序继承了家族的使命，却对这份责任充满抗拒。当结界接连破裂，传说中的灾厄精灵开始苏醒，陈序必须在守护者与普通生活之间做出抉择，并与伙伴们一同找回失落已久的召唤之力。",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20fantasy%20TV%20poster%20of%20a%20summoner%20with%20a%20glowing%20spirit%20sigil%20ring%20and%20a%20manifesting%20elemental%20fairy%20behind%20him%2C%20city%20skyline%20at%20dusk%2C%20violet%20and%20orange%20palette%2C%20dynamic%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=fairy-t10-poster&orientation=portrait",
    tags: ["精灵", "奇幻", "动作", "都市"],
    rating: 8.2,
    popularity: 8340,
  },
];